<template>
  <div class="modal" v-if="visible">
    <!-- this modal is only for login , name the class carefully -->
    <!-- Modal content -->
    <div class="modal-content" v-click-outside="onClickOutside">
      <span class="close" @click="close">&times;</span>
      <div class="product__detail" v-if="product">
        <div class="product__image">
          <div class="product__thumbnails" v-if="product.pictures.length > 0">
            <button
              class="button-transparent up"
              @click="collectionPrev"
              v-if="stackCollection.length > 0"
            ></button>
            <transition-group
              :name="collectionTransitionName"
              :duration="{ enter: 1000, leave: 500 }"
            >
              <img
                v-for="picture in currentCollection"
                :key="picture.id"
                class="product__thumbnail__item"
                :class="{ active: mainImage == picture.file }"
                v-lazy="picture.file"
                @click="changeMainImage(picture)"
              />
            </transition-group>
            <button
              class="button-transparent down"
              @click="collectionNext"
              v-if="stackCollection.length > 0"
            ></button>
          </div>
          <img class="product__image__active" v-lazy="mainImage" />
        </div>
        <div class="product__detail__info">
          <div class="product__name">{{ product.name }}</div>
          <span class="underline lg"></span>
          <div class="product__price">
            <div class="product-item__price">
              <div
                :class="[
                  product.has_discount
                    ? 'product-item__price__old'
                    : 'product-item__price__current',
                ]"
              >
                {{ product.price_with_tax | priceFilter }}
                <span class="product__price__suffix">税込</span>
              </div>
              <div class="product-item__price__new" v-if="product.has_discount">
                {{ product.new_price_with_tax | priceFilter }}
                <span class="product__price__suffix">税込</span>
              </div>
              <!-- {{ product.new_price | priceFilter }}
            <span class="product__price__suffix">税抜</span>-->
            </div>

            <div class="product__action">
              <ProductFavorite
                :loggedIn="loggedIn"
                @change="handleFavoriteChange"
                :product="product"
              ></ProductFavorite>
            </div>
          </div>
          <div class="product__status mb-20">
            <Stock :stock="product.stock"></Stock>
            <span class="product__status__split">|</span>
            <Rating
              :review-infos="product.review_infos"
              extra-class="lg"
            ></Rating>
          </div>
          <div class="product__description">
            <div class="product__description__title">商品説明</div>
            <div class="product__description__content">
              {{ product.short_description }}
            </div>
          </div>
          <div class="product__description">
            <div class="product__colors">
              <strong>色:&nbsp;</strong>
              {{ product.color_i18n }}
              <!-- <span class="product__color" :class="product.color"></span> -->
            </div>
          </div>
          <div class="product__delivery">
            <span class="product__delivery__icon delivery"></span>
            <div class="product__delivery__content">
              {{ nearest_delivery_date }} にお届けするには
            </div>
          </div>
          <div class="product__delivery">
            <span class="product__delivery__icon time"></span>
            <div class="product__delivery__content">
              {{
                this.$dayjs
                  .unix(product.minimum_delivery_time_remaining)
                  .format("MM月DD日HH時mm分")
              }}
              以内にご注文ください
              <div class="product__delivery__content__addon">
                ※ 一部の地域は+1~2日かかります
              </div>
            </div>
          </div>
          <div class="product__quantity">
            <div class="product__quantity__control">
              <button
                type="button"
                class="product__quantity__button"
                :disabled="quantity == 1"
                @click="calcQuantity(quantity, true)"
              >
                -
              </button>
              <input
                type="number"
                class="product__quantity__input"
                min="1"
                max="50"
                v-model="quantity"
                @keydown.e.prevent
              />
              <button
                type="button"
                class="product__quantity__button"
                @click="calcQuantity(quantity, false)"
              >
                +
              </button>
            </div>
          </div>
        </div>
        <div class="product__addtocart">
          <img class="product__addtocart__image" v-lazy="product.image_file" />
          <div class="product__addtocart__name">{{ product.name }}</div>
          <div class="product__addtocart__amount">
            <div class="product__addtocart__amount__title">商品数</div>
            <div class="product__addtocart__amount__value">
              x{{ quantity }} 点
            </div>
          </div>
          <div class="product__addtocart__total">
            <div class="product__addtocart__total__title">合計</div>
            <div class="product__addtocart__total__value">
              {{ totalPrice | priceFilter }}
            </div>
          </div>
          <div class="product__addtocart__button">
            <button type="button" class="button" @click="addToCart">
              カートに入れる
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vClickOutside from "v-click-outside";
import Rating from "./ProductParts/Rating";
import Stock from "./ProductParts/Stock";
import productMixins from "../../mixins/productMixins";
import ProductFavorite from "./ProductFavorite.vue";

export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },
  components: {
    Rating,
    Stock,
    ProductFavorite,
  },
  props: {
    loggedIn: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data: function () {
    return {
      E_CHARACTER_KEY_CODE: 69,
      visible: false,
      product: null,
      mainImage: null,
      currentCollection: [],
      stackCollection: [],
      collectionTransitionName: "",
      quantity: 1,
      changeFavorite: false,
      location: ""
    };
  },
  computed: {
    nearest_delivery_date: function () {
      return this.$dayjs(this.product.nearest_delivery_date).format(
        "MM月DD日 (ddd)"
      );
    },
    totalPrice: function () {
      return this.quantity * this.product.new_price_with_tax;
    },
  },
  mixins: [productMixins],
  methods: {
    changeMainImage: function (picture) {
      this.mainImage = picture.file;
    },
    calcQuantity(quantity, isSub) {
      if (isSub) {
        // when input not empty then calc (quantity || quantity === 0) else keep it value
        this.quantity =
          quantity || quantity === 0 ? parseInt(quantity) - 1 : quantity;
      } else {
        this.quantity =
          quantity || quantity === 0 ? parseInt(quantity) + 1 : quantity;
      }
    },
    open: function (product, location = "") {
      this.product = product;

      this.mainImage =
        this.product.pictures.length > 0
          ? this.product.pictures[0].file
          : this.product.image_file;

      this.currentCollection = this.product.pictures.slice(0, 4);
      this.stackCollection = this._.difference(
        this.product.pictures,
        this.currentCollection
      );

      this.visible = true;
      this.location = location;
    },
    close: function () {
      this.visible = false;
      this.product = null;
      this.changeList();
    },
    onClickOutside: function (el) {
      if (el.target._prevClass == "modal") {
        this.visible = false;
        this.product = null;
        this.changeList();
      }
    },
    changeList: function () {
      if (this.changeFavorite) {
        if (this.location) {
          switch (this.location) {
            case "HomeRecommendedList":
              this.$root.$refs.RecommendedList.$refs.HomeRecommendedList.fetchProducts();
              this.$root.$refs.FavoriteList.fetchFavoriteList();
              break;
            case "DetailRecommendedList":
              this.$root.$refs.RecommendedList.$refs.DetailRecommendedList.fetchProducts();
              break;
            case "FavoriteList":
              this.$root.$refs.FavoriteList.fetchFavoriteList();
              break;
            case "BestSellingList":
              this.$root.$refs.BestSellingList.fetchBestSellingList();
              this.$root.$refs.FavoriteList.fetchFavoriteList();
              break;
            case "ProductsIndex":
              this.$root.$refs.ProductsIndex.fetchProducts();
              break;
            default:
              break;
          }
        }
        this.changeFavorite = false;
      }
    },
    collectionNext: function () {
      this.collectionTransitionName = "fadeUp";

      const removed = this.currentCollection.shift();
      const willAdd = this.stackCollection.shift();

      this.currentCollection.push(willAdd);
      this.stackCollection.push(removed);
      this.mainImage = this.currentCollection[0].file;
    },
    collectionPrev: function () {
      this.collectionTransitionName = "fadeDown";

      const removed = this.currentCollection.pop();
      const willAdd = this.stackCollection.pop();

      this.currentCollection.unshift(willAdd);
      this.stackCollection.unshift(removed);
      this.mainImage = this.currentCollection[0].file;
    },
    handleFavoriteChange: function (status) {
      this.changeFavorite = status;
    }
  },
};
</script>
